import { useAppDispatch } from '@/shared/hooks';

import { accessModel } from '@/entities/access';

export const useCancelSharingInvitation = () => {
  const dispatch = useAppDispatch();

  return async ({ invitationID }: { invitationID: string }) => {
    const { Sharing } = await dispatch(
      accessModel.thunks.cancelSharingInvitation({
        SharingID: invitationID,
      }),
    ).unwrap();

    if (Sharing?.ID) {
      dispatch(accessModel.sharingActions.removeOne(Sharing.ID));
    }
  };
};
